import React from 'react';
import EntityForm from './EntityForm';

function ManageUnitsForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Unit"
            heading="Add New Units"
            insertUrl="insert_manage_units"
            fields={[
                { name: 'name', label: 'Units Name', required: true },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageUnitsForm;
